// ============================================================
// Consentement — une seule source de vérité, réellement lue
// ============================================================
// Jusqu'au 27/08/2026, le bandeau écrivait `cookieConsent` dans localStorage
// et PERSONNE ne le relisait : un visiteur pouvait cliquer « Tout refuser »,
// la mesure d'audience partait quand même. Un bouton qui ment est pire que
// pas de bouton du tout.
//
// Ce que le site fait réellement depuis :
//   - cookies nécessaires (session, panier, sécurité CSRF) : non négociables ;
//   - mesure d'audience first-party, sans cookie, sans identifiant, l'adresse
//     IP n'étant jamais conservée (le serveur n'en garde qu'une empreinte
//     salée du jour). Elle est ACTIVE par défaut — c'est le régime des mesures
//     anonymes — et un refus explicite l'arrête pour de bon ;
//   - plus aucun tiers : Google Analytics n'a jamais été configuré (le code
//     portait l'identifiant bouchon « G-XXXXX »), le script Instagram a été
//     retiré, et Sentry se limite désormais aux erreurs.

const CLE = 'cookieConsent'

/** Événement interne : rouvrir le bandeau depuis le pied de page. */
export const EVENEMENT_OUVRIR = 'mirum:consentement:ouvrir'

export const lireConsentement = () => {
  try {
    const brut = localStorage.getItem(CLE)
    return brut ? JSON.parse(brut) : null
  } catch {
    return null
  }
}

export const enregistrerConsentement = (preferences) => {
  try {
    localStorage.setItem(CLE, JSON.stringify(preferences))
  } catch {
    /* navigation privée, stockage plein : le refus vaut alors pour la visite */
  }
}

/**
 * La mesure est autorisée tant qu'elle n'a pas été explicitement refusée.
 * Toute autre valeur (stockage illisible, choix jamais fait) laisse passer :
 * c'est une mesure anonyme, pas un traceur.
 */
export const mesureAutorisee = () => lireConsentement()?.analytics !== false

/** Rouvre le bandeau (lien « Gérer mes cookies » du pied de page). */
export const ouvrirReglages = () => {
  window.dispatchEvent(new Event(EVENEMENT_OUVRIR))
}
